import * as XLSX from 'xlsx'

const STATUS_LABELS = {
  ACCEPTED: 'Aceptó',
  SENT: 'Notificado, sin respuesta'
}

function formatDateTime (value) {
  if (!value) return ''
  return new Date(value).toLocaleString('es-CO', {
    timeZone: 'America/Bogota',
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  })
}

/**
 * The file the clinic hands over as proof of each authorization, so the
 * evidence columns (reply and WhatsApp message id) go in verbatim.
 */
export function downloadPrivacyRegistry (rows, policyVersion) {
  const sheetRows = rows.map(row => ({
    Paciente: row.patientName || '',
    'Tipo de documento': row.govtIdType || '',
    Documento: row.govtId || '',
    Teléfono: row.number ? String(row.number) : '',
    Estado: STATUS_LABELS[row.status] || row.status,
    'Versión de la política': row.policyVersion,
    'Aviso enviado': formatDateTime(row.sentAt),
    'Fecha de aceptación': formatDateTime(row.acceptedAt),
    'Respuesta del paciente': row.rawUserResponse || '',
    'ID del mensaje de WhatsApp': row.whatsappMessageId || ''
  }))
  const sheet = XLSX.utils.json_to_sheet(sheetRows)
  const book = XLSX.utils.book_new()
  XLSX.utils.book_append_sheet(book, sheet, 'Autorizaciones')
  const today = new Date().toLocaleDateString('en-CA', { timeZone: 'America/Bogota' })
  XLSX.writeFile(book, `registro-autorizaciones-v${policyVersion}-${today}.xlsx`)
}
